import React from 'react';

export const NAV_ITEMS = [
  { label: 'Home', section: 'home' },
  { label: 'About', section: 'about' },
  { label: 'Services', section: 'services' },
  { label: 'Testimonials', section: 'testimonials' },
  { label: 'Insights', section: 'insights' },
  { label: 'Contact', section: 'contact' }
];

export const scrollToSection = (sectionId) => {
  const el = document.getElementById(sectionId);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

export const Navigation = ({ onSelect }) => (
  <nav className="nav-menu" data-testid="primary-nav">
    {NAV_ITEMS.map((item) => (
      <button
        key={item.section}
        onClick={() => onSelect(item.section)}
        className="nav-link"
        data-testid={`nav-${item.section}`}
      >
        {item.label}
      </button>
    ))}
  </nav>
);
